export const dayWorkingTime = [{ from: 0, to: 24 }];

export const taskFields = {
  id: "subtaskID",
  name: "name",
  startDate: "startDate",
  duration: "duration",
  formattedDuration: "formattedDuration",
  progress: "progress",
  dependency: "dependencies",
  isSync: "isSync",
  description: "description",
  workerID: "workerID",
};

export const selectionSettings = {
  mode: "Row",
  type: "Single",
  enableToggle: true,
};

export const splitterSettings = {
  position: "20%",
};

export const toolbar = [
  "Add",
  "Edit",
  "Update",
  "Delete",
  "Cancel",
  "ExpandAll",
  "CollapseAll",
];

export const tooltipTemplate = props => {
  return (
    <div>
      <strong>{props.name}</strong>
      <div>Duration: {props.formattedDuration}</div>
    </div>
  );
};

export const tooltipSettings = {
  showTooltip: true,
  taskbar: tooltipTemplate,
};

export const taskbarTemplate = props => {
  const colorMapping = {
    0: "#dedede", // Light gray
    1: "#226B22", // Dark green
    2: "#6B83B5", // Muted blue
    3: "#DAA520", // Golden yellow
    4: "#CC5500", // Burnt Orange
    5: "#008080", // Teal
  };
  const backgroundColor = colorMapping[props.taskData.workerID];

  return (
    <div
      className="e-gantt-child-taskbar-inner-div e-gantt-child-taskbar"
      style={{ height: "100%", backgroundColor }}
    >
      <div
        className="e-gantt-child-progressbar-inner-div e-gantt-child-progressbar"
        style={{
          width: `${props.ganttProperties.progressWidth}px`,
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        }}
      ></div>
    </div>
  );
};

export const labelSettings = {
  rightLabel: "name",
};
const today = new Date(); // Gets today's date with the current time

// Reset the hours, minutes, seconds, and milliseconds to zero
export const projectStartDate = new Date(today.setHours(0, 0, 0, 0));

export const connectorLineBackground = "rgba(24, 33, 118, 0.5)";
